 import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

import { DialogButtonsDirective } from "../core/components/modal-dialog/dialog-buttons.directive";
import { DialogComponentOutletComponent } from "../core/components/modal-dialog/dialog-component-outlet.component";
import { DialogTitleDirective } from "../core/components/modal-dialog/dialog-title.directive";
import { ModalDialogComponent } from "../core/components/modal-dialog/modal-dialog.component";
import { NotificationComponent } from "../core/components/notification/notification.component";
import { CartUploadService } from "../core/providers/cart-upload/cart-upload.service";
import { TemplateDownloadService } from "../core/providers/template-download/template-download.service";

import { AddressCardComponent } from "./components/address-card/address-card.component";
import { AddressFormComponent } from "./components/address-form/address-form.component";
import { AddressModalComponent } from "./components/address-modal/address-modal.component";
import { CartContentsComponent } from "./components/cart-contents/cart-contents.component";
import { CartTotalsComponent } from "./components/cart-totals/cart-totals.component";
import { ButtonComponent } from "./components/button/button.component";
import { CenteredCardComponent } from "./components/centered-card/centered-card.component";
import { CollectionCardComponent } from "./components/collection-card/collection-card.component";
import { ContactFormComponent } from "./components/contact-form/contact-form.component";
import { DropdownContentDirective } from "./components/dropdown/dropdown-content.directive";
import { DropdownTriggerDirective } from "./components/dropdown/dropdown-trigger.directive";
import { DropdownComponent } from "./components/dropdown/dropdown.component";
import { OrderTotalsComponent } from "./components/order-totals/order-totals.component";
import { RadioCardFieldsetComponent } from "./components/radio-card/radio-card-fieldset.component";
import { RadioCardComponent } from "./components/radio-card/radio-card.component";
import { SignInComponent } from "./components/sign-in/sign-in.component";
import { UploadCartModalComponent } from "./components/upload-cart-modal/upload-cart-modal.component";
import { EanSearchModalComponent } from "./components/ean-search-modal/ean-search-modal.component";
import { ModalComponent } from "./modal/modal.component";
import { FallbackSrcDirective } from "./directives/fallback-src.directive";
import { AssetPreviewPipe } from "./pipes/asset-preview.pipe";
import { ProductImageSrcPipe } from "./pipes/product-image-src.pipe";
import { FormatPricePipe } from "./pipes/format-price.pipe";
import { FormatShippingDatePipe } from "./pipes/format-shipping-date.pipe";
import { ProductUrlPipe } from "./pipes/product-url.pipe";
import { SafeHtmlPipe } from "./pipes/safe-html.pipe";
import { ProductTableComponent } from "./product-table/product-table.component";
import { UploadCartCsvComponent } from "./upload-cart-csv/upload-cart-csv.component";
import { VariantTableComponent } from "./variant-table/variant-table.component";
import { FilterSkeletonComponent } from "./components/skeleton/filter-skeleton/filter-skeleton.component";
import { ProductSkeletonComponent } from "./components/skeleton/product-skeleton/product-skeleton.component";
import { PricelistCardComponent } from "./components/pricelist-card/pricelist-card.component";
import { BreadcrumbsComponent } from "./components/breadcrumbs/breadcrumbs.component";
import { ExportDownloadMenuComponent } from "./components/export-download-menu/export-download-menu.component";
import { CatalogExportModalComponent } from "./components/catalog-export-modal/catalog-export-modal.component";
import { PaginationComponent } from "./components/pagination/pagination.component";

const SHARED_STANDALONE = [
    BreadcrumbsComponent,
    ProductImageSrcPipe,
    FallbackSrcDirective,
];

const SHARED_DECLARATIONS = [
    CartContentsComponent,
    AddressCardComponent,
    SignInComponent,
    AddressFormComponent,
    CenteredCardComponent,
    DropdownComponent,
    OrderTotalsComponent,
    DropdownTriggerDirective,
    DropdownContentDirective,
    DialogButtonsDirective,
    DialogTitleDirective,
    DialogComponentOutletComponent,
    ModalDialogComponent,
    AddressModalComponent,
    CollectionCardComponent,
    NotificationComponent,
    FormatPricePipe,
    FormatShippingDatePipe,
    ProductUrlPipe,
    AssetPreviewPipe,
    SafeHtmlPipe,
    RadioCardComponent,
    RadioCardFieldsetComponent,
    CartTotalsComponent,
    ButtonComponent,
    VariantTableComponent,
    UploadCartCsvComponent,
    UploadCartModalComponent,
    EanSearchModalComponent,
    ProductTableComponent,
    ModalComponent,
    ContactFormComponent,
    FilterSkeletonComponent,
    ProductSkeletonComponent,
    PricelistCardComponent,
    ExportDownloadMenuComponent,
    CatalogExportModalComponent,
    PaginationComponent,
];

const IMPORTS = [
    FontAwesomeModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    RouterModule,
];

@NgModule({
    declarations: SHARED_DECLARATIONS,
    imports: [...IMPORTS, ...SHARED_STANDALONE],
    exports: [...IMPORTS, ...SHARED_DECLARATIONS, ...SHARED_STANDALONE],
    providers: [CartUploadService, TemplateDownloadService],
})
export class SharedModule {}
